export default __webpack_public_path__ + "static/media/mob0.e91b741e.svg";